import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { getUnauthorizedRedirectRoute } from "../utils/routeHelpers";

function RoleProtectedRoute({ allowedRoles, children }) {
  const { profile, loading, isLoggedIn } = useAuth();

  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "#000",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "Arial, sans-serif",
        }}
      >
        Loading...
      </div>
    );
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (!profile?.role || !allowedRoles.includes(profile.role)) {
    return <Navigate to={getUnauthorizedRedirectRoute(profile)} replace />;
  }

  return children;
}

export default RoleProtectedRoute;
